<template>
  <form @submit.prevent="$emit('submit')" class="white-box p30">
    <div class="row">
      <div class="col-sm-6" v-if="!isCreatePage">
        <FieldTextInput name="ID" rules="required" v-model="value.id" :disabled="true" />
      </div>
      <div class="col-sm-6">
        <FieldDate name="Date" rules="required" v-model="value.date_time" :disabled="disabled" />
      </div>
      <div class="col-sm-6">
        <FieldRadio name="Type" rules="required" v-model="value.type" :options="options.TYPES" colClass="col-sm-4"
          :disabled="disabled" />
      </div>
      <div class="col-sm-6">
        <FieldTextInput name="Issue" rules="required" v-model="value.issue" :disabled="disabled" />
      </div>
       <div class="col-sm-6">
        <FieldTextInput name="End Product Application" rules="required" v-model="value.end_product_application"
          :disabled="disabled" />
      </div>
      <div class="col-sm-12">
        <FieldRichEditor name="Complaint/Feedback Description" rules="required" v-model="value.description"
          :disabled="disabled" />
      </div>
      <div class="col-sm-6">
        <FieldMedia name="Photo" rules="required" v-model="value.photo" :disabled="disabled" />
      </div>
      <div class="col-sm-6">
        <FieldAsyncSelect name="Category" rules="required" v-model="value.category_id"
          :options-handlers="getFacCategories" />
      </div>
      <div class="col-sm-6">
        <FieldSelect name="Priority" rules="required" v-model="value.priority" :options="options.PRIORITIES"
          :disabled="disabled" />
      </div>
      <div class="col-sm-6">
        <FieldAsyncSelect :multiple="true" name="Assigned to" rules="required" v-model="value.assign_to"
          :options-handlers="getEmployees" :disabled="disabled" />
      </div>
      <div class="col-sm-12">
        <div class="separator dashed"></div>
      </div>
      <div class="col-sm-6">
        <FieldAsyncSelect name="Customer" rules="required" v-model="value.customer_id" :options-handlers="getCustomers"
          :disabled="disabled" @input="value.pic_id = value.no_hp_pic = null" />
      </div>
      <div class="col-sm-6">
        <FieldTextInput name="Product" rules="required" v-model="value.product" :disabled="disabled" />
      </div>
      <div class="col-sm-6">
        <FieldAsyncSelect name="PIC" rules="required" v-model="value.pic_id" :options-handlers="getPicsByCustomer"
          :disabled="!value.customer_id" @input="data => value.no_hp_pic = data?._data?.phone_number" />
      </div>
      <div class="col-sm-6">
        <FieldTextInput name="No. HP PIC" rules="required" v-model="value.no_hp_pic" :disabled="true" />
      </div>
      <div class="col-sm-6">
        <FieldAsyncSelect name="Grade" rules="required" v-model="value.grade" :disabled="disabled"
          :options-handlers="getFncGrades" />
      </div>
      <div class="col-sm-6">
        <FieldTextInput name="Location" rules="required" v-model="value.location" :disabled="disabled" />
      </div>
      <div class="col-sm-6">
        <FieldTextInput name="Lot No." rules="required" v-model="value.lot_no" :disabled="disabled" />
      </div>
      <div class="col-sm-6">
        <FieldDate name="Shipment Date" rules="required" v-model="value.shipment_date" :disabled="disabled" />
      </div>
      <div class="col-sm-6">
        <FieldAsyncSelect name="Transporter" rules="required" v-model="value.transporter_id"
          :options-handlers="getFacTransporters" :disabled="disabled" />
      </div>
      <div class="col-sm-6">
        <FieldTextInput name="No. Surat Jalan" rules="required" v-model="value.no_surat_jalan" :disabled="disabled" />
      </div>
      <div class="col-sm-6">
        <FieldDate name="Tgl Surat Jalan" rules="required" v-model="value.tgl_surat_jalan" :disabled="disabled" />
      </div>
      <div class="col-sm-6">
        <FieldDate name="Tanggal Deadline" rules="required" v-model="value.deadline_date" :disabled="disabled" />
      </div>
      <div class="col-sm-12">
        <div class="separator dashed"></div>
      </div>
      <div class="col-sm-6">
        <FieldTextInput name="Prepared by" v-model="value.prepared_by" :disabled="true" />
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <button v-if="$route.name !== 'AddFeedback'" v-permissions="'Delete Feedback and Complaint'" @click="$emit('on-delete')" class="btn btn-border-red mx-2"
        type="button">Delete</button>
      <button v-permissions="'Create Feedback and Complaint,Edit Feedback and Complaint'" v-if="!disabled" class="btn btn-orange" type="submit">Save</button>
    </div>
  </form>
</template>
<script>
import FieldDate from '@/components/field/Date.vue';
import FieldMedia from '@/components/field/Media.vue';
import FieldSelect from '@/components/field/Select.vue';
import FieldAsyncSelect from '@/components/field/AsyncSelect.vue';
import FieldRadio from '@/components/field/Radio.vue';
import FieldTextInput from '@/components/field/TextInput.vue';
import FieldRichEditor from '@/components/field/TextArea.vue';

import { TYPES, CATEGORIES, PRIORITIES, TRANSPORTERS } from './constant.js'
import { getOptions } from '@/utils/fetch.js'
import { API_ENDPOINT } from '@/constants/api-endpoint.js'

export default {
  name: "FormFeedback",
  components: {
    FieldTextInput,
    FieldRichEditor,
    FieldRadio,
    FieldDate,
    FieldSelect,
    FieldMedia,
    FieldAsyncSelect
  },
  props: ['value', 'disabled'],
  data() {
    return {
      options: {
        TYPES,
        CATEGORIES,
        PRIORITIES,
        TRANSPORTERS
      }
    }
  },
  computed: {
    isCreatePage() {
      return !!this.$route.path.includes('add')
    },
  },
  methods: {
    getCustomers({ query }) {
      return getOptions(API_ENDPOINT.CUSTOMERS, {
        key: query
      })
    },
    getEmployees({ query }) {
      return getOptions(API_ENDPOINT.EMPLOYEES, {
        key: query
      }, ['code', 'name'], 'nik')
    },
    getFacCategories({ query }) {
      return getOptions(API_ENDPOINT.FAC_CATEGORIES, {
        key: query
      })
    },
    async getFncGrades({ query }) {
      const response = await getOptions(API_ENDPOINT.FNC_GRADE, {
        key: query
      })

      return response.map(r => ({
        text: r?._data, 
        value: r?._data, 
        _data: r?._data
      }))
    },
    getFacTransporters({ query }) {
      return getOptions(API_ENDPOINT.FAC_TRANSPORTERS, {
        key: query
      })
    },
    getPicsByCustomer({ query }) {
      return getOptions(`${API_ENDPOINT.CUSTOMERS}/${this.value.customer_id?.value}/pics`, {
        key: query
      })
    }
  },
}
</script>
